import { render, staticRenderFns } from "./ChartAboveAndBelow18.vue?vue&type=template&id=7722751b&"
import script from "./ChartAboveAndBelow18.vue?vue&type=script&lang=js&"
export * from "./ChartAboveAndBelow18.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports